(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide-menu"] && !Shopify.designMode) return;
  try {
    /* Highlight the menu button for the garment currently on screen, and jump
     to a garment on tap. The jump is scripted (rather than the browser's
     anchor jump) so it lands just below the pinned bar. */
  (() => {
    const init = (menu) => {
      if (menu.dataset.menuReady) return;
      menu.dataset.menuReady = 'true';

      const links = [...menu.querySelectorAll('.size-guide-menu--link')];
      const bar = menu.closest('.shopify-block') || menu;
      const toggle = menu.querySelector('[data-menu-toggle]');
      const currentLabel = menu.querySelector('[data-menu-current]');
      const fallbackLabel = currentLabel ? currentLabel.textContent : '';
      const pairs = links
        .map((link) => [link, document.getElementById(link.getAttribute('href').slice(1))])
        .filter(([, target]) => target);
      if (!pairs.length) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let current = null;
      let jumping = false;
      let settleTimer = null;

      const setActive = (link) => {
        if (link === current) return;
        current = link;
        links.forEach((item) => {
          item.classList.toggle('is-active', item === link);
          if (item === link) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        if (currentLabel) {
          currentLabel.textContent = link ? link.textContent.trim() : fallbackLabel;
        }
      };

      const update = () => {
        if (jumping) return;
        // The active garment is the last one whose top has passed this line
        const line = window.innerHeight * 0.35;
        let active = null;
        pairs.forEach(([link, target]) => {
          if (target.getBoundingClientRect().top <= line) active = link;
        });
        setActive(active);
      };

      // Phone drop-down
      const setOpen = (open) => {
        if (!toggle) return;
        menu.toggleAttribute('data-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      if (toggle) {
        toggle.addEventListener('click', () => setOpen(!menu.hasAttribute('data-open')));
        document.addEventListener('click', (event) => {
          if (menu.hasAttribute('data-open') && !menu.contains(event.target)) setOpen(false);
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && menu.hasAttribute('data-open')) {
            setOpen(false);
            toggle.focus();
          }
        });
      }

      let queued = false;
      const queue = () => {
        if (jumping) {
          // Treat the jump as done once scrolling has been quiet for a moment
          clearTimeout(settleTimer);
          settleTimer = setTimeout(() => {
            jumping = false;
            update();
          }, 160);
          return;
        }
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          update();
        });
      };

      pairs.forEach(([link, target]) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          setOpen(false);
          const stickyTop = parseFloat(getComputedStyle(bar).top) || 0;
          const offset = stickyTop + bar.offsetHeight + 16;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;

          setActive(link);
          jumping = true;
          clearTimeout(settleTimer);
          settleTimer = setTimeout(() => {
            jumping = false;
            update();
          }, 1200);
          window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          if (history.replaceState) history.replaceState(null, '', link.hash);
        });
      });

      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      update();
    };

    const start = () => document.querySelectorAll('.size-guide-menu').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
